import React from "react";
import styled, { css } from "styled-components";
import Text from "../shared/Text";
import Icon from "../shared/Icon";
interface ReplyProps {
  title: string;
  meaning?: string | null;
  region: string;
}

const Reply: React.FC<ReplyProps> = props => {
  return (
    <Wrapper>
      <SayingAndRegion>
        <Icon size={15} icon="story" fillColor="darkBlue" />
        <Text as="h3">{props.title}</Text>
        <Text as="p" color="midGrey">
          {props.region}
        </Text>
      </SayingAndRegion>
      <div>
        <Text small={true} as="p">
          {props.meaning}
        </Text>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: column;
`;
const SayingAndRegion = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
  justify-content: space-between;
  padding-top: 1rem;
  padding-bottom: 0.2rem;
  ${({ theme }) => css`
    svg {
      transform: translate(-120%, 60%);
      position: absolute;
      top: 0;
      left: 0;
      fill: ${theme.colors.darkBlue};
    }
  `};
`;

export default Reply;
